import type { MouseEventHandler } from 'react';
import React from 'react';

import { WithFlysiteUrls } from 'components/HOC/WithFlysiteUrls/WithFlysiteUrls';
import type { FlysiteUrls } from 'hooks/useFlysiteUrls';
import { useTranslations } from 'utils';

type ContactProps = {
  onClick?: MouseEventHandler<HTMLAnchorElement>;
};

const ContactComponent = ({
  contactUrl,
  onClick,
}: ContactProps & FlysiteUrls) => {
  const i18n = useTranslations();
  const handleClick: MouseEventHandler<HTMLAnchorElement> = evt => {
    onClick?.(evt);
  };

  return (
    <a
      href={contactUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
    >
      {i18n.t('step.aside.contact')}
    </a>
  );
};

const Contact = WithFlysiteUrls(ContactComponent);

export { Contact };
